/**
 * Bridges React Router's `navigate` to non-React code (the intent dispatcher).
 * A module-level ref is set by <NavigationBridge/> on mount.
 */
type NavigateFn = (path: string) => void;

let navigateRef: NavigateFn | null = null;

/** Called by <NavigationBridge/> to publish the router's navigate fn. */
export function setBridgeNavigate(fn: NavigateFn | null): void {
  navigateRef = fn;
}

/** Navigate from outside React. No-ops if the bridge isn't mounted yet. */
export function bridgeNavigate(path: string): void {
  navigateRef?.(path);
}

/** Test-only: reset the module ref. */
export function __clearBridgeForTests(): void {
  navigateRef = null;
}
